import { isBrightColor } from "@/features/collection-form/utils/color";
import { getImage } from "@/features/collection-form/utils/helpers";
import { MasonryGalleryCustomProps } from "@/features/testimonial-gallery/api/types";
import { CSSProperties } from "react";

export const TestimonialWallHero = ({
  ...styles
}: MasonryGalleryCustomProps) => {
  const { pageTitle, subtitle, enableCTA, ctaTitle, ctaURL, logo } = styles;

  const cssStyles = getStyles(styles);

  return (
    <header style={cssStyles.header}>
      {logo && (
        <img
          src={getImage(logo, "/default-logo.png")}
          alt="Logo"
          style={cssStyles.logo}
        />
      )}

      <div
        style={{
          maxWidth: "65rem",
          margin: "0 auto",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          position: "relative",
          zIndex: 10,
        }}
      >
        <h1
          style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)",
            fontWeight: "700",
            lineHeight: "1.2",
          }}
        >
          {pageTitle}
        </h1>

        <p
          style={{
            fontSize: "clamp(1.1rem, 2vw, 1.3rem)",
            opacity: 0.9,
            maxWidth: "45rem",
            margin: "0 auto",
          }}
        >
          {subtitle}
        </p>

        {enableCTA && ctaURL && (
          <a
            href={ctaURL}
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
            style={{ ...cssStyles.button }}
          >
            {ctaTitle}
          </a>
        )}
      </div>

      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%)",
          mixBlendMode: "multiply",
        }}
      />
    </header>
  );
};

function getStyles(
  styles: MasonryGalleryCustomProps,
): Record<"button" | "header" | "logo", CSSProperties> {
  return {
    button: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0.75rem 2rem",
      borderRadius: "9999px",
      fontSize: "1.1rem",
      fontWeight: "500",
      transition: "all 0.2s",
      margin: "1rem auto 0",
      textDecoration: "none",
      border: "2px solid transparent",
      backgroundColor: styles.buttonColor,
      color: isBrightColor(styles.buttonColor || "") ? "#000" : "#fff",
    },
    header: {
      background: styles.primaryColor,
      color: isBrightColor(styles.primaryColor || "") ? "black" : "white",
      fontFamily: styles.font,
      padding: "8rem 2rem",
      position: "relative",
    },
    logo: {
      position: "absolute",
      top: "2rem",
      left: "2rem",
      width: `${styles.logoSize}px`,
      height: `${styles.logoSize}px`,
      borderRadius: styles.isSquareLogo ? "unset" : "50%",
      zIndex: 20,
    },
  };
}
